type MergeTwoIntersection<A, B> = {
  [K in keyof A & keyof B]: A[K] & B[K];
};

export type TLocalesCombined<T extends unknown[]> = T extends [infer First, ...infer Rest]
  ? Rest extends []
    ? First
    : MergeTwoIntersection<First, TLocalesCombined<Rest>>
  : object;

function mergeLocales<LocA, LocB>(a: LocA, b: LocB): TLocalesCombined<[LocA, LocB]>;
function mergeLocales<LocA, LocB, LocC>(a: LocA, b: LocB, c: LocC): TLocalesCombined<[LocA, LocB, LocC]>;
function mergeLocales<LocA, LocB, LocC, LocD>(
  a: LocA,
  b: LocB,
  c: LocC,
  d: LocD,
): TLocalesCombined<[LocA, LocB, LocC, LocD]>;
function mergeLocales<LocA, LocB, LocC, LocD, LocE>(
  a: LocA,
  b: LocB,
  c: LocC,
  d: LocD,
  e: LocE,
): TLocalesCombined<[LocA, LocB, LocC, LocD, LocE]>;
function mergeLocales<LocA, LocB, LocC, LocD, LocE, LocF>(
  a: LocA,
  b: LocB,
  c: LocC,
  d: LocD,
  e: LocE,
  f: LocF,
): TLocalesCombined<[LocA, LocB, LocC, LocD, LocE, LocF]>;
function mergeLocales(...locales: Record<string, Record<string, unknown>>[]) {
  const results: Record<string, Record<string, unknown>> = {};

  for (const locale of locales) {
    for (const [localeCode, messages] of Object.entries(locale)) {
      if (!results[localeCode]) {
        results[localeCode] = {};
      }

      results[localeCode] = { ...results[localeCode], ...messages };
    }
  }

  return results;
}

export { mergeLocales };
